import {AxiosResponse} from 'axios';

export function createObjectURL(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function revokeObjectURL(url: string) {
  URL.revokeObjectURL(url);
}

function createDownloadLink(url: string, filename: string, target?: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  if (target) {
    link.target = target;
  }
  document.body.appendChild(link);
  return link;
}

function download(link: HTMLAnchorElement, url: string) {
  link.click();
  link.remove();
  revokeObjectURL(url);
}

export function downloadBlob(url: string, filename: string) {
  download(createDownloadLink(url, filename, '_blank'), url);
}

export function resolveAndDownloadBlob(res: AxiosResponse, filename = 'file') {
  const decodedFilename = decodeURI(filename);
  const url = createObjectURL(new Blob([res.data]));
  downloadBlob(url, decodedFilename);
}
